export default __webpack_public_path__ + "static/media/close.26e2fe2e.svg";